export default __webpack_public_path__ + "static/media/waitingRoom.8c3bd2a5.png";